// Import model
import { UpdateSfExternalLinkRequest } from '../models/UpdateSfExternalLinkRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSfExternalLinkRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSfExternalLinkRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSfExternalLinkRequest instance
   */
  static deserialize(json: string): UpdateSfExternalLinkRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSfExternalLinkRequest instance
   */
  static fromObject(obj: any): UpdateSfExternalLinkRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSfExternalLinkRequest');
    }


    const instance: UpdateSfExternalLinkRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSfExternalLinkRequest instances
   */
  static deserializeArray(json: string): UpdateSfExternalLinkRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSfExternalLinkRequest instance to a JSON string
   */
  static serialize(instance: UpdateSfExternalLinkRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSfExternalLinkRequest instance to a plain object
   */
  static toObject(instance: UpdateSfExternalLinkRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of UpdateSfExternalLinkRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSfExternalLinkRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
